// apis/services.js
import { http } from "./http";
import endpoints from "./endpoints";

export const getAllFaqsApi = () => {
  return http.get(endpoints.getAllFaqs);
};

export const stayConnectedApi = (data) => {
  return http.postFormData(endpoints.stayConnected, data);
};


export const addcontactApi = (data) => {
  return http.post(endpoints.contactUs, data);
};

export const getAllTestimonialApi = () => {
  return http.get(endpoints.testimonials);
};

export const aboutUsApi = () => {
  return http.get(endpoints.aboutUs);
};

export const platformApi = () => {
  return http.get(endpoints.platforms);
};

export const blogsApi = () => {
  return http.get(endpoints.blog);
};

export const termsConditionApi = () => {
  return http.get(endpoints.termsCondition);
};

export const privacyPolicyApi = () => {
  return http.get(endpoints.privacyPolicy);
};

export const leadershipApi = () => {
  return http.get(endpoints.leadership);
};


export const recentBlogsApi = () => {
  return http.get(endpoints.recentBlogs);
};


export const newsLetterApi = (data) => {
  return http.post(`${endpoints.stayConnected}`,data);
};

export const getVideoApi = () => {
  return http.get(`${endpoints.video}`);
};

export const infoApi = () => {
  return http.get(`${endpoints.info}`);
};

export const downloadApi = (email) => {
  return http.post(`${endpoints.download}`,email);
};

export const blogDetailsApi = (id) => {
  return http.get(`${endpoints.blogDetails}/?id=${id}`);
};
